import {
    CBM_WIZARD_SET_ACTIVE_STEP,
    CBM_WIZARD_SET_REPORT_TYPE,
    CBM_WIZARD_SET_REPORTING_YEAR,
    CBM_WIZARD_SET_REPORTING_PERIOD,
    CBM_WIZARD_SET_SESSION_ID,
    CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST,
    CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS,
    CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE,
    CBM_WIZARD_SAVE_DRAFT_REQUEST,
    CBM_WIZARD_SAVE_DRAFT_SUCCESS,
    CBM_WIZARD_SAVE_DRAFT_FAILURE,
    CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST,
    CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS,
    CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE,
    CBM_WIZARD_EXTRACTION_STATUS_REQUEST,
    CBM_WIZARD_EXTRACTION_STATUS_SUCCESS,
    CBM_WIZARD_EXTRACTION_STATUS_FAILURE,
    CBM_WIZARD_EXTRACT_RECORDS_REQUEST,
    CBM_WIZARD_EXTRACT_RECORDS_SUCCESS,
    CBM_WIZARD_EXTRACT_RECORDS_FAILURE,
    CBM_WIZARD_EXTRACT_LAYOUT_REQUEST,
    CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS,
    CBM_WIZARD_EXTRACT_LAYOUT_FAILURE,
    CBM_WIZARD_SET_EXTRACT_PAGE,
    CBM_WIZARD_SET_EXTRACT_PAGE_SIZE,
    CBM_WIZARD_SET_EXTRACT_SEARCH,
    CBM_WIZARD_SET_EXTRACT_SORT,
    CBM_WIZARD_EXPORT_CSV_REQUEST,
    CBM_WIZARD_EXPORT_CSV_SUCCESS,
    CBM_WIZARD_EXPORT_CSV_FAILURE,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE,
    CBM_WIZARD_VALIDATION_TRIGGER_REQUEST,
    CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS,
    CBM_WIZARD_VALIDATION_TRIGGER_FAILURE,
    CBM_WIZARD_VALIDATION_STATUS_REQUEST,
    CBM_WIZARD_VALIDATION_STATUS_SUCCESS,
    CBM_WIZARD_VALIDATION_STATUS_FAILURE,
    CBM_WIZARD_VALIDATION_RESULTS_REQUEST,
    CBM_WIZARD_VALIDATION_RESULTS_SUCCESS,
    CBM_WIZARD_VALIDATION_RESULTS_FAILURE,
    CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER,
    CBM_WIZARD_SET_VALIDATION_REPORT_FILTER,
    CBM_WIZARD_SET_VALIDATION_RULE_FILTER,
    CBM_WIZARD_SET_VALIDATION_FIELD_FILTER,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE,
    CBM_WIZARD_EXPORT_SUMMARY_REQUEST,
    CBM_WIZARD_EXPORT_SUMMARY_SUCCESS,
    CBM_WIZARD_EXPORT_SUMMARY_FAILURE,
    CBM_WIZARD_TRIGGER_EXPORT_REQUEST,
    CBM_WIZARD_TRIGGER_EXPORT_SUCCESS,
    CBM_WIZARD_TRIGGER_EXPORT_FAILURE,
    CBM_WIZARD_EXPORT_STATUS_REQUEST,
    CBM_WIZARD_EXPORT_STATUS_SUCCESS,
    CBM_WIZARD_EXPORT_STATUS_FAILURE,
    CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST,
    CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS,
    CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE,
    CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST,
    CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS,
    CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE,
    CBM_WIZARD_RESET,
    CBM_WIZARD_HYDRATE_SESSION,
    CBM_WIZARD_FETCH_TERMS_REQUEST,
    CBM_WIZARD_FETCH_TERMS_SUCCESS,
    CBM_WIZARD_FETCH_TERMS_FAILURE,
    CBM_WIZARD_SET_TERM,
    CBM_WIZARD_SET_EXTRACTION_CONTEXT,
    SET_RCS_P1_FIELD,
    SET_RCS_P1_PREFILL,
    SET_RCS_EXTRACTED,
    RCS_VALIDATION_LOADING,
    RCS_VALIDATION_LOADED,
    SET_TFADS_FIELD,
    TFADS_SELECT_ITEMS_REQUEST,
    TFADS_SELECT_ITEMS_SUCCESS,
    TFADS_SELECT_ITEMS_FAILURE,
    TFADS_EXTRACT_REQUEST,
    TFADS_EXTRACT_SUCCESS,
    TFADS_EXTRACT_FAILURE,
    TFADS_DOWNLOAD_REQUEST,
    TFADS_DOWNLOAD_SUCCESS,
    TFADS_DOWNLOAD_FAILURE
} from './cbmWizardTypes';
import { picksCensusTerm } from '../data/cbmReportMeta';

const initialState = {
    activeStep: 1,
    furthestStep: 1,
    contextVersion: 0,
    sessionId: null,
    reportType: null,
    reportingYear: null,
    reportingPeriod: null,
    reportTypes: [],
    reportingYears: [],
    reportingPeriods: [],
    institution: null,
    terms: {
        items: [],
        loading: false
    },
    selectedTermId: null,
    resumeExtractionStatusPending: false,
    resumeTargetStep: null,
    isLoading: false,
    isSaving: false,
    error: null,
    extraction: {
        status: null,
        recordCount: null,
        distinctStudentCount: null,
        startTime: null,
        endTime: null,
        errorMessage: null,
        isLoading: false,
        precheckFlaggedCount: 0,
        precheckCleanCount: 0,
        precheckFieldBreakdown: [],
    },
    extractRecords: {
        records: [],
        totalCount: 0,
        pageNumber: 1,
        pageSize: 50,
        searchTerm: '',
        sortColumn: '',
        sortAscending: true,
        reportType: '',
        reportingYear: '',
        reportingPeriod: '',
        dataSources: [],
        isLoading: false,
    },
    fieldLayout: {
        columns: [],
        isLoading: false,
    },
    csvExporting: false,
    precheckReportExporting: false,
    validation: {
        triggering: false,
        status: null,
        errorCount: 0,
        warningCount: 0,
        totalRows: 0,
        results: [],
        eligibleRecords: [],
        loading: false,
        error: null,
        severityFilter: '',
        reportFilter: '',
        ruleFilter: '',
        fieldFilter: '',
        exporting: false,
    },
    export: {
        summary: null,
        summaryLoading: false,
        summaryError: null,
        triggering: false,
        triggerError: null,
        status: null,
        statusLoading: false,
        downloading: false,
        downloadError: null,
        manifestDownloading: false,
    },
    rcsP1: {
        officialName: '', officialTitle: '', officialEmail: '',
        catalogUrl: '', websiteUrl: '', certified: false,
        submissionDate: '2025-08-15', prefilled: false,
    },
    rcsP2Extracted: false,
    rcsValidation: { rows: 0, errors: [], warnings: [], cleanCount: 0, cleanPct: '', loading: false, loaded: false },
    tfads: {
        institutionType: '',
        year: '',
        academicYear: '',
        reportCycle: '',
        selectItems: { institutionType: [], reportCycle: [], finAcademicYear: [] },
        extracting: false,
        extracted: false,
        records: [],
        recordCount: 0,
        downloading: false,
    },
};

const sameContextValue = (left, right) => String(left ?? '') === String(right ?? '');

const hasCurrentCbmExtraction = (state) => {
    if (state.extraction?.status !== 'Completed') return false;
    if (state.reportType === 'CBM0E1' && !(state.extraction.recordCount > 0)) return false;
    if (!picksCensusTerm(state.reportType)) return true;
    const selectedTermIsValid = (state.terms?.items || []).some(
        (term) => String(term.termCalendarId) === String(state.selectedTermId)
    );
    const expectedContext = JSON.stringify([
        state.sessionId,
        state.reportType,
        String(state.reportingYear ?? ''),
        state.reportingPeriod ?? '',
        String(state.selectedTermId ?? '')
    ]);
    return selectedTermIsValid && state.extraction.contextKey === expectedContext;
};

const canAdvanceFromCurrentStep = (state) => {
    if (['TFADS', 'TFADS-TX'].includes(state.reportType)) {
        if (state.activeStep === 1) return Boolean(state.reportType && state.tfads?.year && state.tfads?.academicYear && state.tfads?.reportCycle);
        if (state.activeStep === 2) return Boolean(state.tfads?.extracted);
        return false;
    }
    if (state.activeStep === 1) return Boolean(state.reportType && state.reportingYear && state.reportingPeriod);
    if (state.activeStep === 2) return hasCurrentCbmExtraction(state);
    if (state.activeStep === 3) return hasCurrentCbmExtraction(state) && state.validation?.status === 'Complete';
    return false;
};

const canNavigateToStep = (state, targetStep) => {
    if (targetStep <= state.activeStep) return true;
    if (targetStep > state.furthestStep && targetStep !== state.activeStep + 1) return false;
    if (targetStep === state.activeStep + 1) return canAdvanceFromCurrentStep(state);
    if (['TFADS', 'TFADS-TX'].includes(state.reportType)) {
        if (targetStep === 2) return Boolean(state.reportType && state.tfads?.year && state.tfads?.academicYear && state.tfads?.reportCycle);
        if (targetStep === 3) return Boolean(state.tfads?.extracted);
        return false;
    }
    if (targetStep === 2) return Boolean(state.reportType && state.reportingYear && state.reportingPeriod);
    // Step 3 is where validation runs. Existing extraction is enough to revisit
    // that step; completed validation remains a prerequisite for Step 4.
    if (targetStep === 3) return hasCurrentCbmExtraction(state);
    if (targetStep === 4) return hasCurrentCbmExtraction(state) && state.validation?.status === 'Complete';
    return false;
};

const clearContextWork = (state, resetNavigation = true) => ({
    ...state,
    contextVersion: (state.contextVersion || 0) + 1,
    resumeExtractionStatusPending: false,
    resumeTargetStep: null,
    ...(resetNavigation ? { activeStep: 1, furthestStep: 1 } : {}),
    extraction: { ...initialState.extraction },
    extractRecords: { ...initialState.extractRecords },
    csvExporting: false,
    precheckReportExporting: false,
    validation: { ...initialState.validation },
    export: { ...initialState.export }
});

const cbmWizardReducer = (state = initialState, action) => {
    // Every async operation tied to a reporting context carries its starting version.
    // A late response from the previous year/period/report must never repopulate cleared work.
    if (action.meta?.contextVersion !== undefined && action.meta.contextVersion !== state.contextVersion) return state;

    switch (action.type) {
        case CBM_WIZARD_SET_ACTIVE_STEP:
            if (!Number.isInteger(action.payload) || action.payload < 1) return state;
            if (action.payload > (['TFADS', 'TFADS-TX'].includes(state.reportType) ? 3 : 4) || !canNavigateToStep(state, action.payload)) return state;
            return {
                ...state,
                activeStep: action.payload,
                furthestStep: Math.max(state.furthestStep, action.payload),
                // User navigation wins over an outstanding resume-status response.
                resumeTargetStep: null,
                resumeExtractionStatusPending: false
            };

        case CBM_WIZARD_FETCH_TERMS_REQUEST:
            return {
                ...state,
                terms: { items: [], loading: true, error: false, requestId: action.meta?.requestId }
            };

        case CBM_WIZARD_FETCH_TERMS_SUCCESS:
            if (action.meta?.requestId !== state.terms.requestId) return state;
            {
                const selectedTermIsValid = action.payload.some((term) => String(term.termCalendarId) === String(state.selectedTermId));
                const invalidResumedTerm = state.resumeTargetStep && !selectedTermIsValid;
            return {
                ...state,
                terms: { items: action.payload, loading: false, error: false, requestId: action.meta?.requestId },
                selectedTermId: selectedTermIsValid ? state.selectedTermId : null,
                ...(invalidResumedTerm ? {
                    activeStep: 2,
                    furthestStep: 2,
                    resumeTargetStep: null,
                    resumeExtractionStatusPending: false
                } : {})
            };
            }

        case CBM_WIZARD_FETCH_TERMS_FAILURE:
            if (action.meta?.requestId !== state.terms.requestId) return state;
            return {
                ...state,
                terms: { items: [], loading: false, error: true, requestId: action.meta?.requestId },
                resumeExtractionStatusPending: false,
                resumeTargetStep: null,
                activeStep: state.resumeTargetStep ? 2 : state.activeStep,
                furthestStep: state.resumeTargetStep ? 2 : state.furthestStep
            };

        case CBM_WIZARD_SET_TERM:
            if (sameContextValue(state.selectedTermId, action.payload)) return state;
            return {
                ...clearContextWork(state, false),
                // A changed term invalidates Step 3/4 access, even for a resumed draft
                // whose saved furthestStep was ahead of the newly selected context.
                activeStep: Math.min(state.activeStep, 2),
                furthestStep: Math.min(state.furthestStep, 2),
                resumeExtractionStatusPending: false,
                resumeTargetStep: null,
                selectedTermId: action.payload
            };

        case CBM_WIZARD_SET_EXTRACTION_CONTEXT:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    contextKey: action.payload
                },
                resumeExtractionStatusPending: false,
                ...(action.payload === null ? { resumeTargetStep: null } : {})
            };

        case CBM_WIZARD_HYDRATE_SESSION: {
            const isTfads = ['TFADS', 'TFADS-TX'].includes(action.payload.reportType);
            // A CBM draft can return to its completed extraction/validation in this tab.
            // Only keep that work when it belongs to the same saved reporting context.
            const sameCbmContext = !isTfads && state.sessionId === action.payload.id &&
                state.reportType === action.payload.reportType &&
                String(state.reportingYear) === String(action.payload.reportingYear) &&
                state.reportingPeriod === action.payload.reportingPeriod &&
                (state.selectedTermId ?? null) === (action.payload.termCalendarId ?? null);
            const contextVersion = sameCbmContext ? state.contextVersion : (state.contextVersion || 0) + 1;
            return {
                ...(sameCbmContext ? state : initialState),
                contextVersion,
                reportTypes: state.reportTypes,
                reportingYears: state.reportingYears,
                reportingPeriods: state.reportingPeriods,
                institution: state.institution,
                sessionId: action.payload.id,
                selectedTermId: action.payload.termCalendarId ?? null,
                resumeExtractionStatusPending: !isTfads && action.payload.currentStep >= 3,
                terms: { items: [], loading: false, error: false },
                reportType: isTfads ? 'TFADS' : action.payload.reportType,
                reportingYear: action.payload.reportingYear,
                reportingPeriod: action.payload.reportingPeriod,
                tfads: {
                    ...initialState.tfads,
                    selectItems: state.tfads.selectItems,
                    institutionType: action.payload.tfadsInstitutionType || '',
                    year: isTfads ? String(action.payload.reportingYear || '') : '',
                    academicYear: action.payload.tfadsAcademicYearId || '',
                    reportCycle: action.payload.tfadsReportCycle || ''
                },
                activeStep: isTfads ? 1 : action.payload.currentStep || 1,
                furthestStep: isTfads ? 1 : Math.max(sameCbmContext ? state.furthestStep : 1, action.payload.currentStep || 1),
                ...(!isTfads ? {
                    activeStep: Math.min(action.payload.currentStep || 1, action.payload.currentStep >= 3 ? 2 : 4),
                    furthestStep: Math.min(Math.max(sameCbmContext ? state.furthestStep : 1, action.payload.currentStep || 1), action.payload.currentStep >= 3 ? 2 : 4),
                    resumeTargetStep: action.payload.currentStep >= 3 ? 3 : null
                } : { resumeTargetStep: null })
            };
        }

        case CBM_WIZARD_SET_REPORT_TYPE:
            if (sameContextValue(state.reportType, action.payload)) return state;
            return {
                ...clearContextWork(state),
                reportType: action.payload,
                selectedTermId: null,
                terms: { items: [], loading: false, error: false }
            };

        case CBM_WIZARD_SET_REPORTING_YEAR:
            if (sameContextValue(state.reportingYear, action.payload)) return state;
            return {
                ...clearContextWork(state),
                reportingYear: action.payload,
                selectedTermId: null,
                terms: { items: [], loading: false, error: false }
            };

        case CBM_WIZARD_SET_REPORTING_PERIOD:
            if (sameContextValue(state.reportingPeriod, action.payload)) return state;
            return {
                ...clearContextWork(state),
                reportingPeriod: action.payload,
                selectedTermId: null,
                terms: { items: [], loading: false, error: false }
            };

        case CBM_WIZARD_SET_SESSION_ID:
            if (state.sessionId === action.payload) return state;
            return {
                ...clearContextWork(state),
                sessionId: action.payload,
                selectedTermId: null,
                terms: { items: [], loading: false, error: false }
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                reportTypes: action.payload.reportTypes || [],
                reportingYears: action.payload.reportingYears || [],
                reportingPeriods: action.payload.reportingPeriods || [],
                institution: action.payload.institution || null
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: 'Failed to load select items'
            };

        case CBM_WIZARD_SAVE_DRAFT_REQUEST:
            return {
                ...state,
                isSaving: true,
                error: null
            };

        case CBM_WIZARD_SAVE_DRAFT_SUCCESS:
            return {
                ...state,
                isSaving: false,
                sessionId: action.payload?.id || state.sessionId
            };

        case CBM_WIZARD_SAVE_DRAFT_FAILURE:
            return {
                ...state,
                isSaving: false,
                error: 'Failed to save draft'
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: true,
                    status: 'Pending',
                    errorMessage: null,
                    contextKey: action.meta?.contextKey || null
                }
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    precheckFlaggedCount: action.payload?.precheckFlaggedCount || 0,
                    precheckCleanCount: action.payload?.precheckCleanCount || 0,
                    precheckFieldBreakdown: action.payload?.precheckFieldBreakdown || [],
                    contextKey: action.meta?.contextKey || state.extraction.contextKey
                }
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    status: 'Failed',
                    errorMessage: action.payload || 'Failed to start extraction',
                    contextKey: action.meta?.contextKey || state.extraction.contextKey
                }
            };

        case CBM_WIZARD_EXTRACTION_STATUS_REQUEST:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACTION_STATUS_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            {
                const extractionCompleted = action.payload?.extractionStatus === 'Completed';
                const restoreStep = extractionCompleted && state.resumeTargetStep && hasCurrentCbmExtraction({
                    ...state,
                    extraction: {
                        ...state.extraction,
                        status: action.payload.extractionStatus,
                        recordCount: action.payload?.recordCount || 0
                    }
                }) ? state.resumeTargetStep : null;
            return {
                ...state,
                extraction: {
                    status: action.payload?.extractionStatus || null,
                    recordCount: action.payload?.recordCount || 0,
                    distinctStudentCount: action.payload?.distinctStudentCount ?? null,
                    startTime: action.payload?.startTime || null,
                    endTime: action.payload?.endTime || null,
                    errorMessage: action.payload?.errorMessage || null,
                    isLoading: false,
                    precheckFlaggedCount: action.payload?.precheckFlaggedCount || 0,
                    precheckCleanCount: action.payload?.precheckCleanCount || 0,
                    precheckFieldBreakdown: action.payload?.precheckFieldBreakdown || [],
                    contextKey: action.meta?.contextKey || state.extraction.contextKey
                },
                ...(restoreStep ? { activeStep: restoreStep, furthestStep: Math.max(state.furthestStep, restoreStep), resumeTargetStep: null } : {}),
                ...(!extractionCompleted && ['Failed', 'NotStarted'].includes(action.payload?.extractionStatus) ? {
                    ...(state.resumeTargetStep ? { activeStep: 2, furthestStep: 2 } : {}),
                    resumeTargetStep: null,
                    resumeExtractionStatusPending: false
                } : {})
            };
            }

        case CBM_WIZARD_EXTRACTION_STATUS_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    errorMessage: 'Failed to fetch extraction status'
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_REQUEST:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                extractRecords: {
                    records: action.payload?.records || [],
                    totalCount: action.payload?.totalCount || 0,
                    pageNumber: action.payload?.pageNumber || 1,
                    pageSize: action.payload?.pageSize || 50,
                    searchTerm: action.payload?.searchTerm || '',
                    reportType: action.payload?.reportType || '',
                    reportingYear: action.payload?.reportingYear || '',
                    reportingPeriod: action.payload?.reportingPeriod || '',
                    dataSources: action.payload?.dataSources || [],
                    isLoading: false,
                    contextVersion: action.meta?.contextVersion ?? state.contextVersion,
                    sortColumn: state.extractRecords.sortColumn,
                    sortAscending: state.extractRecords.sortAscending
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_FAILURE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    isLoading: false
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_REQUEST:
            return {
                ...state,
                fieldLayout: {
                    ...state.fieldLayout,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS:
            return {
                ...state,
                fieldLayout: {
                    columns: action.payload || [],
                    isLoading: false
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_FAILURE:
            return {
                ...state,
                fieldLayout: {
                    ...state.fieldLayout,
                    isLoading: false
                }
            };

        case CBM_WIZARD_SET_EXTRACT_PAGE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    pageNumber: action.payload
                }
            };

        case CBM_WIZARD_SET_EXTRACT_PAGE_SIZE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    pageSize: action.payload,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_SET_EXTRACT_SEARCH:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    searchTerm: action.payload,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_SET_EXTRACT_SORT:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    sortColumn: action.payload.sortColumn,
                    sortAscending: action.payload.sortAscending,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_EXPORT_CSV_REQUEST:
            return {
                ...state,
                csvExporting: true
            };

        case CBM_WIZARD_EXPORT_CSV_SUCCESS:
            return {
                ...state,
                csvExporting: false
            };

        case CBM_WIZARD_EXPORT_CSV_FAILURE:
            return {
                ...state,
                csvExporting: false
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST:
            return {
                ...state,
                precheckReportExporting: true
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS:
            return {
                ...state,
                precheckReportExporting: false
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE:
            return {
                ...state,
                precheckReportExporting: false
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: true,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: false,
                    status: 'Pending'
                }
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: false,
                    error: 'Failed to trigger validation'
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: true
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    status: action.payload?.validationStatus || null,
                    errorCount: action.payload?.errorCount || 0,
                    warningCount: action.payload?.warningCount || 0,
                    totalRows: action.payload?.totalRows || 0,
                    loading: false,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: false,
                    error: 'Failed to fetch validation status'
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: true,
                    error: null,
                    resultsRequestId: action.meta?.requestId
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            if (state.validation.resultsRequestId !== undefined && action.meta?.requestId !== state.validation.resultsRequestId) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    results: action.payload?.results || [],
                    eligibleRecords: action.payload?.eligibleRecords || [],
                    errorCount: action.payload?.totalErrors ?? state.validation.errorCount,
                    warningCount: action.payload?.totalWarnings ?? state.validation.warningCount,
                    totalRows: action.payload?.totalRows ?? state.validation.totalRows,
                    loading: false,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            if (state.validation.resultsRequestId !== undefined && action.meta?.requestId !== state.validation.resultsRequestId) return state;
            return {
                ...state,
                validation: {
                    ...state.validation,
                    results: [],
                    eligibleRecords: [],
                    loading: false,
                    error: 'Failed to fetch validation results'
                }
            };

        case CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    severityFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_REPORT_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    reportFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_RULE_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    ruleFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_FIELD_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    fieldFilter: action.payload
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: true
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: false
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: false
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    summaryLoading: true,
                    summaryError: null
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    summary: action.payload,
                    summaryLoading: false,
                    summaryError: null
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    summaryLoading: false,
                    summaryError: action.payload || 'Failed to load export summary'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: true,
                    triggerError: null,
                    status: 'Pending'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: false,
                    status: action.payload?.exportStatus || 'Pending'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: false,
                    triggerError: action.payload || 'Failed to trigger export',
                    status: 'Failed'
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    statusLoading: true
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_SUCCESS:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    status: action.payload?.exportStatus || null,
                    statusLoading: false,
                    summary: state.export.summary ? {
                        ...state.export.summary,
                        fileName: action.payload?.fileName ?? state.export.summary.fileName,
                        expiresAt: action.payload?.expiresAt ?? state.export.summary.expiresAt,
                        totalRecordCount: action.payload?.recordCount ?? state.export.summary.totalRecordCount,
                        excludedRecordCount: action.payload?.excludedRecordCount ?? state.export.summary.excludedRecordCount
                    } : null,
                    triggerError: action.payload?.exportStatus === 'Failed'
                        ? action.payload?.errorMessage || 'Export failed'
                        : state.export.triggerError
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_FAILURE:
            if (action.meta?.contextKey && action.meta.contextKey !== state.extraction.contextKey) return state;
            return {
                ...state,
                export: {
                    ...state.export,
                    statusLoading: false
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: true,
                    downloadError: null
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: false,
                    downloadError: null
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: false,
                    downloadError: action.payload || 'Failed to download extract file'
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: true
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: false
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: false
                }
            };

        case SET_RCS_P1_FIELD:
            return { ...state, rcsP1: { ...state.rcsP1, [action.payload.key]: action.payload.value } };

        case SET_RCS_P1_PREFILL:
            return { ...state, rcsP1: { ...state.rcsP1, ...action.payload, prefilled: true } };

        case SET_RCS_EXTRACTED:
            return { ...state, rcsP2Extracted: action.payload };

        case RCS_VALIDATION_LOADING:
            return { ...state, rcsValidation: { ...state.rcsValidation, loading: true } };

        case RCS_VALIDATION_LOADED:
            return { ...state, rcsValidation: { ...action.payload, loading: false, loaded: true } };

        case SET_TFADS_FIELD:
            return { ...state, tfads: { ...state.tfads, [action.payload.key]: action.payload.value } };

        case TFADS_SELECT_ITEMS_REQUEST:
            return { ...state, tfads: { ...state.tfads } };

        case TFADS_SELECT_ITEMS_SUCCESS:
            return {
                ...state,
                tfads: {
                    ...state.tfads,
                    selectItems: {
                        institutionType: action.payload.institutionType || [],
                        reportCycle: action.payload.reportCycle || [],
                        // The API pads the list with a blank SelectItem at index 0 — the
                        // dropdown has its own empty state, so drop unlabelled entries.
                        finAcademicYear: (action.payload.finAcademicYear || []).filter(i => i && i.displayText)
                    }
                }
            };

        case TFADS_SELECT_ITEMS_FAILURE:
            return { ...state };

        case TFADS_EXTRACT_REQUEST:
            return {
                ...state,
                tfads: { ...state.tfads, extracting: true }
            };

        case TFADS_EXTRACT_SUCCESS:
            return {
                ...state,
                tfads: {
                    ...state.tfads,
                    extracting: false,
                    extracted: true,
                    records: action.payload || [],
                    recordCount: (action.payload || []).length
                }
            };

        case TFADS_EXTRACT_FAILURE:
            return {
                ...state,
                tfads: { ...state.tfads, extracting: false }
            };

        case TFADS_DOWNLOAD_REQUEST:
            return {
                ...state,
                tfads: { ...state.tfads, downloading: true }
            };

        case TFADS_DOWNLOAD_SUCCESS:
            return {
                ...state,
                tfads: { ...state.tfads, downloading: false }
            };

        case TFADS_DOWNLOAD_FAILURE:
            return {
                ...state,
                tfads: { ...state.tfads, downloading: false }
            };

        case CBM_WIZARD_RESET:
            // Reference lookups survive a reset — only wizard/session state clears.
            // rcsP1/rcsP2Extracted/rcsValidation reset automatically via ...initialState spread.
            return {
                ...initialState,
                // Never reuse a context version: requests started before reset must
                // remain stale even when a later wizard repeats the same selections.
                contextVersion: (state.contextVersion || 0) + 1,
                reportTypes: state.reportTypes,
                reportingYears: state.reportingYears,
                reportingPeriods: state.reportingPeriods,
                institution: state.institution,
                tfads: { ...initialState.tfads, selectItems: state.tfads.selectItems }
            };

        default:
            return state;
    }
};

export default cbmWizardReducer;
